import { UUIDTypes } from 'uuid'

// This enum name matches the enum used in the API, using a
// different name would require mapping values in the client.
export enum LoomWoolLotOfferStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  UnderOffer = 'UNDER_OFFER',
}

export type Offer = {
  expiryDateTime?: Date | null
  offerFrom?: string | null
  paymentDate?: Date | null
  personalisedComment?: string | null
  lines?: WoolLotOffer[] | null
}

export type OfferDecisions = {
  decisions: {
    woolLotOfferId: UUIDTypes
    accepted: boolean | undefined
  }[]
}

export type WoolLotOffer = {
  id?: UUIDTypes

  // Wool lot related fields
  code?: string | null
  internalReferenceCode: string
  coreTestColourYZ?: number | null
  coreTestMicron?: number | null
  coreTestStapleLengthGreasy?: number | null
  coreTestStapleStrength?: number | null
  coreTestVegetableMatterBase?: number | null
  coreTestYield?: number | null
  interlotWarning: boolean
  internalComment?: string | null
  lineNumber?: string | null
  mainBaleHeaderPurchaseDescription?: string | null
  netKg?: number | null
  purchaseAccountName?: string | null
  qualityScheme2?: string | null
  qualitySchemeWarning: boolean
  saleNumber?: string | null
  season?: string | null
  stationBrand?: string | null
  stationRecordNumber?: string | null
  totalBales?: number | null
  typeCurrent?: string | null

  // Prices in cents per kilo
  cleanMarketPrice?: number | null
  cleanOfferPrice?: number | null
  greasyMarketPrice?: number | null
  greasyOfferPrice?: number | null

  // Value in dollars per lot
  valueAdd?: number | null
  displayValueAdd?: boolean | null

  // Offer related fields
  brandPartner?: string | null
  status?: LoomWoolLotOfferStatus | null
}

export type WoolLotOfferDecisionCallback = (woolLotId: UUIDTypes, decision: boolean) => void
